/**
 * A simple EventEmitter class to manage custom events.
 */
class EventEmitter {
	constructor() {
		/**
		 * An object to store event listeners.
		 * @type {Object.<string, Function[]>}
		 */
		this.events = {};
	}

	/**
	 * Registers a new listener for the specified event.
	 * @param {string} event - The name of the event.
	 * @param {Function} listener - The callback function to execute when the event is emitted.
	 */
	on(event, listener) {
		if (!this.events[event]) {
			this.events[event] = [];
		}
		this.events[event].push(listener);
	}

	/**
	 * Removes a listener for the specified event.
	 * @param {string} event - The name of the event.
	 * @param {Function} listener - The callback function to remove.
	 */
	off(event, listener) {
		if (this.events[event]) {
			this.events[event] = this.events[event].filter(
				(l) => l !== listener
			);
		}
	}

	/**
	 * Emits the specified event, calling all registered listeners with the provided data.
	 * @param {string} event - The name of the event.
	 * @param {*} [data] - The data to pass to the event listeners.
	 */
	emit(event, data) {
		if (this.events[event]) {
			this.events[event].forEach((listener) => listener(data));
		}
	}
}

export const eventEmitter = new EventEmitter();
